import { DataAuthorizationModel } from '../insight/config.insight.model';
import { Tab } from '../insight/experimental.tabset';
import { TabContext } from '../insight/tabset.model';

import { InsightTabConfig } from './insight-explorer.model';

export const storeStateMapper = (state: any): RootState =>
    state.insightExplorer;

export interface RootState {
    pending: {
        init?: boolean;
    };
    tabs: Array<Tab<TabContext<InsightTabConfig>>>;
    selectedTab?: string;
    permissions?: DataAuthorizationModel[];
}

export const defaultState = (): RootState => ({
    pending: {},
    tabs: [],
});
